import {
  ArrowCircleLeftIcon,
  ArrowSquareOutIcon,
  ArrowSquareUpRightIcon,
  BellIcon,
  CalendarDotsIcon,
  CaretDoubleDownIcon,
  CaretDoubleLeftIcon,
  CaretDoubleRightIcon,
  CaretDoubleUpIcon,
  CaretDownIcon,
  CaretLeftIcon,
  CaretRightIcon,
  CaretUpDownIcon,
  CaretUpIcon,
  ChatIcon,
  CheckCircleIcon,
  CheckIcon,
  CircleIcon,
  CircleNotchIcon,
  ClockIcon,
  CloudArrowUpIcon,
  CreditCardIcon,
  CurrencyCircleDollarIcon,
  DotIcon,
  DotOutlineIcon,
  DotsThreeIcon,
  DotsThreeVerticalIcon,
  DownloadIcon,
  EnvelopeSimpleIcon,
  EyeIcon,
  EyeSlashIcon,
  FileCsvIcon,
  FilePdfIcon,
  FilmScriptIcon,
  FilmStripIcon,
  FolderOpenIcon,
  GearSixIcon,
  HeartIcon,
  HouseIcon,
  HouseLineIcon,
  InfoIcon,
  KeyboardIcon,
  LifebuoyIcon,
  ListIcon,
  LockIcon,
  MagnifyingGlassIcon,
  MinusIcon,
  MonitorPlayIcon,
  PencilIcon,
  PlusCircleIcon,
  PlusIcon,
  ProhibitIcon,
  QuestionIcon,
  SignOutIcon,
  SlidersIcon,
  SmileySadIcon,
  TableIcon,
  TrashIcon,
  UserCircleIcon,
  UserIcon,
  UsersIcon,
  UsersThreeIcon,
  WalletIcon,
  WarningCircleIcon,
  WarningIcon,
  WarningOctagonIcon,
  WifiHighIcon,
  WifiSlashIcon,
  XCircleIcon,
  XIcon,
  type Icon as PhosphorIcon,
} from "@phosphor-icons/react";

export const SR_ICONS = {
  arrowCircleLeft: ArrowCircleLeftIcon,
  arrowSquareOut: ArrowSquareOutIcon,
  arrowSquareUpRight: ArrowSquareUpRightIcon,
  bell: BellIcon,
  calendar: CalendarDotsIcon,
  check: CheckIcon,
  chevronDoubleDown: CaretDoubleDownIcon,
  chevronDoubleLeft: CaretDoubleLeftIcon,
  chevronDoubleRight: CaretDoubleRightIcon,
  chevronDoubleUp: CaretDoubleUpIcon,
  chevronDown: CaretDownIcon,
  chevronLeft: CaretLeftIcon,
  chevronRight: CaretRightIcon,
  chevronUp: CaretUpIcon,
  chevronUpDown: CaretUpDownIcon,
  circle: CircleIcon,
  circleNotch: CircleNotchIcon,
  clock: ClockIcon,
  close: XIcon,
  creditCard: CreditCardIcon,
  currencyCircleDollar: CurrencyCircleDollarIcon,
  delete: TrashIcon,
  destructive: WarningCircleIcon,
  dot: DotIcon,
  dotOutline: DotOutlineIcon,
  dotsThreeVertical: DotsThreeVerticalIcon,
  download: DownloadIcon,
  edit: PencilIcon,
  ellipsis: DotsThreeIcon,
  error: WarningOctagonIcon,
  eyeOpen: EyeIcon,
  eyeSlash: EyeSlashIcon,
  fileCsv: FileCsvIcon,
  filePdf: FilePdfIcon,
  filmScript: FilmScriptIcon,
  filmStrip: FilmStripIcon,
  folderOpen: FolderOpenIcon,
  gear: GearSixIcon,
  heart: HeartIcon,
  houseLine: HouseLineIcon,
  house: HouseIcon,
  info: InfoIcon,
  keyboard: KeyboardIcon,
  lifeBuoy: LifebuoyIcon,
  list: ListIcon,
  loading: CircleNotchIcon,
  lock: LockIcon,
  mail: EnvelopeSimpleIcon,
  message: ChatIcon,
  minus: MinusIcon,
  monitorPlay: MonitorPlayIcon,
  people: UsersIcon,
  person: UserIcon,
  plus: PlusIcon,
  plusCircle: PlusCircleIcon,
  prohibit: ProhibitIcon,
  question: QuestionIcon,
  search: MagnifyingGlassIcon,
  settings: GearSixIcon,
  signOut: SignOutIcon,
  sliders: SlidersIcon,
  smileySad: SmileySadIcon,
  success: CheckCircleIcon,
  table: TableIcon,
  upload: CloudArrowUpIcon,
  userCircle: UserCircleIcon,
  usersThree: UsersThreeIcon,
  wallet: WalletIcon,
  warning: WarningIcon,
  wifi: WifiHighIcon,
  wifiDisconnected: WifiSlashIcon,
  x: XIcon,
  xCircle: XCircleIcon,
} as const satisfies Record<string, PhosphorIcon>;
